import React, { useMemo } from 'react';
import { SvgIcon } from '../../../Icon';
import KubitTooltip from '../../../KubitTooltip';
import {
  getTodayDatePicker,
  getYesterdayDatePicker,
  convertInternalDateFormatToDisplayDateFormat,
} from '../utils';
import * as DatePickerHeaderUI from './DatePickerHeaderUI';
import DatePickerTypeSelector from '../DatePickerTypeSelector';
import { IDatePickerFieldsFragment } from '../../../../utils/apollo/graphqlSchema';
import { GraphQLLocalDate } from '../../../../utils/types';

interface IProps {
  endDate: GraphQLLocalDate;
  datePicker: IDatePickerFieldsFragment;
  onChange: (newDatePicker: IDatePickerFieldsFragment) => void;
}

const DatePickerHeader = ({ datePicker, onChange, endDate }: IProps) => {
  const { today, yesterday } = useMemo(
    () => ({
      yesterday: getYesterdayDatePicker(endDate),
      today: getTodayDatePicker(endDate),
    }),
    [endDate],
  );

  return (
    <DatePickerHeaderUI.Container>
      <DatePickerTypeSelector datePicker={datePicker} onChange={onChange} />
      <DatePickerHeaderUI.ShortcutDayContainer>
        <KubitTooltip
          content={`${convertInternalDateFormatToDisplayDateFormat(yesterday.start)}`}
          placement="top-start"
          noOpenDelay={true}
        >
          <DatePickerHeaderUI.ShortcutDay onClick={() => onChange(yesterday)}>
            <SvgIcon name="yesterday" width={35} height={18} />
          </DatePickerHeaderUI.ShortcutDay>
        </KubitTooltip>
        <KubitTooltip
          content={`${convertInternalDateFormatToDisplayDateFormat(today.start)}`}
          placement="top-start"
          noOpenDelay={true}
        >
          <DatePickerHeaderUI.ShortcutDay onClick={() => onChange(today)}>
            <SvgIcon name="today" width={22} height={18} />
          </DatePickerHeaderUI.ShortcutDay>
        </KubitTooltip>
      </DatePickerHeaderUI.ShortcutDayContainer>
    </DatePickerHeaderUI.Container>
  );
};

export default DatePickerHeader;
